import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  restaurant: (state: State) => state.restaurant,
  restaurantInitData: (state: State) => state.restaurantInitData,
  restaurants: (state: State) => state.restaurants,
  restaurantCount: (state: State) => state.restaurantCount,
} as GetterTree<State, any>;
